import { hasVerifiedPaymentTotal } from './paymentReconciliation';
import { financialBalanceStatus, isOpenPo } from './financialStatusHelpers';
export function invoiceBadge(data) {
  const status = financialBalanceStatus(data.summary, data.shipping_summary, data.po);
  if (!hasVerifiedPaymentTotal(data.payment_reconciliation, data.summary)) return {label: 'Tagihan diperiksa', tone: 'neutral'};
  if (isOpenPo(data.po) && ['daily', 'underpaid', 'paid', 'overpaid'].includes(status.state)) return {label: 'Tagihan harian', tone: 'neutral'};
  if (status.state === 'underpaid') return {label: 'Invoice FINAL', tone: 'amber'};
  if (status.state === 'paid' || status.state === 'overpaid') return {label: 'Invoice LUNAS', tone: 'green'};
  if (status.state === 'pending_shipping') return {label: 'Tunggu ongkir', tone: 'neutral'};
  return {label: status.state === 'no_goods' ? 'Tidak ada DAPAT' : status.state === 'pending_goods' ? 'Menunggu barang' : 'Tagihan diperiksa', tone: 'neutral'};
}
